// drag drop upload
import Dropzone from "dropzone";

var galleryLoading = function (show){
    if(show){
        $('.gallery-modal-spinner').show();
    }else{
        $('.gallery-modal-spinner').hide();
    }
}

var loadGalleryCategories = function() {
    
    galleryLoading(true);

    $.ajax({
        url: '/gallery',
        method: 'GET',
        success: function(responseHTML) {
            
            $('.modal-content').html(responseHTML);

            // hide loader
            galleryLoading(false);
        }
    });
}

var loadGalleryImages = function(categoryId) {
    
    galleryLoading(true);

    $.ajax({
        url: '/gallery/category/'+categoryId,
        method: 'GET',
        success: function(responseHTML) {
            
            $('.modal-content').html(responseHTML);

            // hide loader
            galleryLoading(false);
        }
    });
}
document.addEventListener('DOMContentLoaded', function() {

    /**
   * Drag and drop upload for sections (communal spaces, events, etc.)
   */
   if(document.getElementById('dropzone-upload-form-gallery') !== null){
        
        // init dropzone
        let myDropzone = new Dropzone("#dropzone-upload-form-gallery", {
            addRemoveLinks: true,
            // Mirror the server rule (mimes:jpeg,bmp,png,webp|max:5120) so a
            // mismatch is refused instantly with a reason (MT-062).
            acceptedFiles: 'image/jpeg,image/png,image/bmp,image/webp',
            maxFilesize: 5,
            dictInvalidFileType: 'Only JPEG, PNG, BMP or WebP images can be uploaded.',
            dictFileTooBig: 'Image is {{filesize}} MB — the limit is {{maxFilesize}} MB.',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        });

        // A rejected upload used to fail silently: Laravel answers 422 with
        // {message, errors} (a shape Dropzone does not display) and nginx
        // answers a huge file with a 413 HTML page. Put a readable reason on
        // the tile either way (MT-062).
        myDropzone.on("error", function(file, message, xhr) {
            var text = message;
            if (message && typeof message === 'object') {
                text = (message.errors && message.errors.file && message.errors.file[0]) || message.message || 'Upload failed.';
            } else if (xhr && xhr.status === 413) {
                text = 'Image is too large for the server to accept.';
            } else if (typeof message !== 'string' || /<[a-z][\s\S]*>/i.test(message)) {
                text = 'Upload failed' + (xhr && xhr.status ? ' (HTTP ' + xhr.status + ')' : '') + '.';
            }
            var el = file.previewElement && file.previewElement.querySelector('.dz-error-message');
            if (el) {
                el.textContent = text;
                el.style.display = 'block';
                el.style.opacity = '1';
                // The message is absolutely positioned over the tile; let clicks
                // pass through so the "Remove file" link underneath still works.
                el.style.pointerEvents = 'none';
                // Dropzone places this below the tile, over the "Remove file"
                // link; sit it on the (rejected) image instead.
                el.style.top = '0';
                el.style.bottom = 'auto';
                el.classList.add('dz-error-message--above');
            }
            // The error mark reads as a close button — make it one.
            var mark = file.previewElement && file.previewElement.querySelector('.dz-error-mark');
            if (mark) {
                mark.style.cursor = 'pointer';
                mark.title = 'Remove';
                mark.addEventListener('click', function () { myDropzone.removeFile(file); });
            }
        });

        // Saving while an upload is still in flight silently drops it — the
        // hidden input below only exists once the upload has succeeded. Hold
        // the form's submit buttons until the queue is empty (MT-064).
        var dzForm = document.querySelector('#dropzone-upload-form-gallery').closest('form');
        var submitButtons = (dzForm || document).querySelectorAll('button[type="submit"], input[type="submit"]');
        function setSaving(locked) {
            submitButtons.forEach(function (btn) {
                btn.disabled = locked;
                btn.title = locked ? 'Please wait for image uploads to finish' : '';
            });
        }
        myDropzone.on("addedfile", function () { setSaving(true); });
        myDropzone.on("queuecomplete", function () { setSaving(false); });

        // on file upload success, append to the body to capture in the store/update method.
        myDropzone.on("success", function(file, response) {
            $(file.previewElement).append( $('<input type="hidden" name="gallery_image_files[]" id="gallery_image_files[]" class="gallery_image_files dz-media-id" value="' + response +'">') );
        });

        $(document).on('click', '.btn-delete-category-image', function(e){
            e.preventDefault();

            // Permanent delete — this endpoint removes the stored image, so it
            // must never fire from a stray click (MT-052 audit: the one
            // permanent action that never had a guard).
            if (!confirm('Delete this image permanently?')) {
                return;
            }

            var imgId = $(this).data('image-id');

            $.ajax({
                url: '/gallery-categories/deleteUpload', 
                method: 'POST',
                data: {
                    image_id: imgId,
                    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                success: function(response) {

                    if(response.success){
                        $.ajax({
                            url: window.location.href,
                            method: 'GET',
                            success: function(response) {
                                let imageHTML = $(response).find('.card-body-images-refresh').html();
                                $('.card-body-images-refresh').html(imageHTML);
                            }
                        })
                    }

                }
            })
        })
    }


    var galleryModal = document.getElementById('galleryModal');

    if(galleryModal !== null){
        
        let selectedFiles = [];

        // is hidden
        galleryModal.addEventListener('hide.bs.modal', function () {
            galleryLoading(true);
            $('.modal-content').html('');
        });

        // is going to show
        galleryModal.addEventListener('show.bs.modal', function () {
            loadGalleryCategories();
        });

        // click "browse" on category
        $(document).on('click', '.btn-browse-category', function(e){
            let categoryId = $(this).data('category-id');
            loadGalleryImages(categoryId);
        });

        $(document).on('click', '.btn-gallery-categories', function(e){
            loadGalleryCategories();
        });

        $(document).on('click', '.btn-select-image-from-gallery', function(e){
            
            $(this).toggleClass('selected');

            var currText = $(this).text().trim();

            if(currText == 'Select Image'){
                $(this).text('Selected');
            }else{
                $(this).text('Select Image');
            }

            var selectedFileName = $(this).parent().find('.file_name').val();
            var selectedFileId   = $(this).parent().find('.file_id').val();
            var object = {
                'file': selectedFileName,
                'id': selectedFileId
            };

            // if in Array, remove if not add...

            var found = false;

            for (let selectedIndex = 0; selectedIndex < selectedFiles.length; selectedIndex++) {
                // if already in the selected array, need to remove
                if(selectedFiles[selectedIndex].id == selectedFileId) {
                    selectedFiles.splice(selectedIndex, 1); // remove from selectedFiles
                    found = true; // mark as found
                    break;
                }
            }

            if(!found){
                selectedFiles.push(object);
            }
        
            var totalSelected = selectedFiles.length;
            $('.btn-gallery-selected span').text(totalSelected);

        });

        $(document).on('click', '.btn-gallery-choose-selected', function(){

            // generate ui html
            var htmlStart = '';
            for (let sfIndex = 0; sfIndex < selectedFiles.length; sfIndex++) {
                const element = selectedFiles[sfIndex];
                htmlStart += `
                    <div class="col-md-2">
                        <div class="gallery-preview">
                            <input type="hidden" name="gallery_image_id[]" value="`+element.id+`">
                            <input type="hidden" name="gallery_image_file[]" value="`+element.file+`">
                            <img src="`+element.thumbnail_url+`" class="img-fluid w-100" alt="">
                            <a href="javascript: void(0)" class="btn-delete-gallery-preview-item btn btn-danger btn-sm mt-1 text-white">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>
                    </div>`; 
            }

            // add images to ui
            if(selectedFiles.length > 0){
                $('.gallery-selected-images').css('display', 'flex');
            }else{
                $('.gallery-selected-images').hide();
            }

            $('.gallery-selected-images').html(htmlStart);
            
            // finally, close modal
            var galleryModalInstance = bootstrap.Modal.getInstance(galleryModal)
            galleryModalInstance.hide();

            // empty selected files
            selectedFiles = [];

        });

        $(document).on('click', '.btn-delete-gallery-preview-item', function(e){
            if(confirm('Are you sure you do not wish to use this image?')){
                // first parent is preview-element, next is column (col-md-...)
                $(this).parent().parent().remove();

                if($('.gallery-selected-images div').length == 0) {
                    $('.gallery-selected-images').hide();
                }
            }
        });
    }
    
});